/* ==================================================================
   CUSTOM: to-scale ring sizer.

   Appended to the END of the content in two places:
     1. Inside the "Ring Size Chart" popup on product pages
     2. At the bottom of /pages/ring-size-guide

   This lives in assets/ (a real .js file) rather than inline in the Liquid
   snippet ON PURPOSE. An earlier version was an inline <script> inside
   snippets/ring-sizer.liquid and Liquid mangled it, producing a silent
   SyntaxError that killed the whole script. Asset files are served raw and are
   never passed through the Liquid renderer. Keep the JS here.

   THE SIZE TABLE BELOW IS TAKEN FROM THE TRAVEL RING CO SIZE CHART.
   It is NOT the generic US table (which puts US 7 at 17.35mm). Ours has US 7 at
   17.5mm. If the printed size chart is ever revised, revise this table to match.

   WHOLE AND HALF SIZES ONLY. The printed chart also lists quarter sizes but we
   do not sell them, so they are excluded here.

     - Whole sizes US 4 to 12 = standard range, available to buy
     - Half sizes             = custom rings only, not stocked
     - Sizes 11 and 12 exist on men's rings

   WHY CALIBRATION IS REQUIRED
   CSS millimetres are not physical millimetres. Browsers assume 96 CSS px per
   inch regardless of the real display, so a 17.5mm circle is a different
   physical size on a laptop, a phone and a 4K monitor. We therefore calibrate
   against a known object. Two methods are offered:

     Bank card - 85.60 x 53.98 mm worldwide (ISO 7810, format ID-1)
     Ruler     - centimetre marks

   CARD ORIENTATION. On mobile the card is drawn PORTRAIT (53.98mm wide) rather
   than landscape (85.6mm wide). At true scale a landscape card is 325px+ and
   simply does not fit a phone screen, which made calibration impossible.
   Rotated, it is only ~205-270px wide and fits comfortably. Desktop keeps the
   familiar landscape orientation. Same card, same maths - only the axis swaps.

   The PRINTED chart needs no calibration (printers use real physical units), so
   CSS mm there is genuinely accurate. It carries both a card box and a ruler so
   the customer can verify their printer did not scale the page.
   ================================================================== */
(function () {
  /* us, mm (internal diameter), au (AU/UK), eu */
  var SIZES = [
    { us: '4', mm: 15.1, au: 'H1/2', eu: '47.5' },
    { us: '4.5', mm: 15.5, au: 'I1/2', eu: '48.5' },
    { us: '5', mm: 15.9, au: 'J1/2', eu: '50' },
    { us: '5.5', mm: 16.3, au: 'K1/2', eu: '51' },
    { us: '6', mm: 16.7, au: 'L1/2', eu: '52.5' },
    { us: '6.5', mm: 17.1, au: 'M1/2', eu: '54' },
    { us: '7', mm: 17.5, au: 'N1/2', eu: '55' },
    { us: '7.5', mm: 17.9, au: 'O1/2', eu: '56.25' },
    { us: '8', mm: 18.3, au: 'P1/2', eu: '57.25' },
    { us: '8.5', mm: 18.7, au: 'Q1/2', eu: '58.5' },
    { us: '9', mm: 19.1, au: 'R1/2', eu: '60' },
    { us: '9.5', mm: 19.5, au: 'S1/2', eu: '61.25' },
    { us: '10', mm: 19.9, au: 'T1/2', eu: '62.5' },
    { us: '10.5', mm: 20.1, au: 'U', eu: '63' },
    { us: '11', mm: 20.5, au: 'V', eu: '64.25' },
    { us: '11.5', mm: 20.9, au: 'W', eu: '65.5' },
    { us: '12', mm: 21.3, au: 'X', eu: '66.5' }
  ];

  var DEFAULT_INDEX = 6; /* US 7 */

  var CARD_LONG_MM = 85.6;  /* ISO 7810 ID-1 */
  var CARD_SHORT_MM = 53.98;
  var RULER_MM = 80;
  var DEFAULT_PX_PER_MM = 96 / 25.4;
  var STORE_KEY = 'trc_ring_cal';
  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function isWhole(us) {
    return parseFloat(us) % 1 === 0;
  }

  function loadCal() {
    try {
      var v = parseFloat(window.localStorage.getItem(STORE_KEY));
      if (v > 1 && v < 20) return v;
      return null;
    } catch (e) {
      return null;
    }
  }

  function saveCal(v) {
    try {
      window.localStorage.setItem(STORE_KEY, String(v));
    } catch (e) {}
  }

  function printChart() {
    var p = [];
    p.push('<!doctype html><html><head><meta charset="utf-8">');
    p.push('<title>Travel Ring Co - Ring Size Chart</title>');
    p.push('<style>');
    p.push('body{font-family:Helvetica,Arial,sans-serif;margin:14mm;color:#111}');
    p.push('h1{font-size:15pt;margin:0 0 3mm;text-transform:uppercase;letter-spacing:.08em}');
    p.push('h2{font-size:10pt;margin:0 0 2mm;text-transform:uppercase;letter-spacing:.06em}');
    p.push('p{font-size:8.5pt;line-height:1.5;margin:0 0 3mm}');
    p.push('.checks{display:flex;gap:8mm;align-items:flex-end;margin:0 0 6mm;flex-wrap:wrap}');
    p.push('.card{width:85.6mm;height:53.98mm;border:0.3mm dashed #999;border-radius:3mm;');
    p.push('display:flex;align-items:center;justify-content:center;font-size:7.5pt;color:#777;text-align:center}');
    p.push('.ruler{position:relative;width:100mm;height:14mm;border-bottom:0.4mm solid #111}');
    p.push('.ruler i{position:absolute;bottom:0;width:0.25mm;background:#111}');
    p.push('.ruler b{position:absolute;bottom:7mm;font-size:7pt;font-weight:400;transform:translateX(-50%)}');
    p.push('.grid{display:flex;flex-wrap:wrap;gap:5mm}');
    p.push('.row{display:flex;align-items:center;gap:3mm;width:44mm}');
    p.push('.circle{border:0.3mm solid #111;border-radius:50%;flex:0 0 auto}');
    p.push('.meta{font-size:7.5pt;line-height:1.35}');
    p.push('.meta strong{display:block;font-size:10pt}');
    p.push('.meta span{color:#777;display:block}');
    p.push('.half strong{color:#999}');
    p.push('@media print{@page{margin:10mm}}');
    p.push('</style></head><body>');

    p.push('<h1>Travel Ring Co - Ring Size Chart</h1>');
    p.push('<p><strong>Print at 100% scale.</strong> In the print dialog set Scale to 100% and ');
    p.push('turn OFF "Fit to page" or "Shrink to fit".</p>');

    p.push('<h2>First, check the scale</h2>');
    p.push('<p>Both checks below must match. If they do not, the page was scaled and every ');
    p.push('circle on this sheet will be the wrong size.</p>');
    p.push('<div class="checks">');
    p.push('<div class="card">Your bank card should fit<br>this box exactly<br>(85.6 x 54 mm)</div>');

    p.push('<div class="ruler">');
    for (var t = 0; t <= 100; t++) {
      var h = t % 10 === 0 ? 6 : t % 5 === 0 ? 4 : 2.5;
      var wdt = t % 10 === 0 ? 0.4 : 0.25;
      p.push('<i style="left:' + t + 'mm;height:' + h + 'mm;width:' + wdt + 'mm"></i>');
      if (t % 10 === 0) p.push('<b style="left:' + t + 'mm">' + t / 10 + '</b>');
    }
    p.push('</div>');
    p.push('</div>');

    p.push('<h2>Then measure</h2>');
    p.push('<p>Place a ring you already own over the circles. Your size is the circle whose ');
    p.push('outline sits just inside the inner edge of the ring. Our standard range is whole ');
    p.push('sizes only (US 4 to 12). Half sizes are available on custom rings.</p>');
    p.push('<div class="grid">');

    for (var i = 0; i < SIZES.length; i++) {
      var s = SIZES[i];
      var half = !isWhole(s.us);
      p.push('<div class="row' + (half ? ' half' : '') + '">');
      p.push('<div class="circle" style="width:' + s.mm + 'mm;height:' + s.mm + 'mm"></div>');
      p.push('<div class="meta">');
      p.push('<strong>US ' + s.us + (half ? ' (custom)' : '') + '</strong>');
      p.push('<span>AU/UK ' + s.au.replace('1/2', '&frac12;') + ' &middot; EU ' + s.eu + '</span>');
      p.push('<span>' + s.mm.toFixed(1) + ' mm</span>');
      p.push('</div></div>');
    }

    p.push('</div></body></html>');

    var w = window.open('', '_blank');
    if (!w) return;
    w.document.open();
    w.document.write(p.join(''));
    w.document.close();
    w.focus();
    setTimeout(function () {
      w.print();
    }, 400);
  }

  function findPill(size) {
    var inputs = document.querySelectorAll('.product-form__input--pill input[type=radio]');
    for (var i = 0; i < inputs.length; i++) {
      if ((inputs[i].value || '').trim() === size) return inputs[i];
    }
    return null;
  }

  function build(root) {
    var pxPerMm = loadCal() || DEFAULT_PX_PER_MM;

    var card = root.querySelector('.trc-sizer__card');
    var ruler = root.querySelector('.trc-sizer__ruler');
    var ring = root.querySelector('.trc-sizer__ring');
    var calSlider = root.querySelector('.trc-sizer__slider--cal');
    var sizeSlider = root.querySelector('.trc-sizer__slider--size');
    var sizeOut = root.querySelector('.trc-sizer__size');
    var mmOut = root.querySelector('.trc-sizer__mm');
    var convOut = root.querySelector('.trc-sizer__conv');
    var statusOut = root.querySelector('.trc-sizer__status');
    var chooseBtn = root.querySelector('[data-action=choose]');

    sizeSlider.min = '0';
    sizeSlider.max = String(SIZES.length - 1);
    sizeSlider.step = '1';
    sizeSlider.value = String(DEFAULT_INDEX);

    var hasPills = !!document.querySelector('.product-form__input--pill');
    if (!hasPills && chooseBtn) chooseBtn.style.display = 'none';

    calSlider.value = pxPerMm;

    var ticks = [];
    var labels = [];
    (function buildRuler() {
      for (var t = 0; t <= RULER_MM; t++) {
        var tick = document.createElement('span');
        tick.className = 'trc-sizer__tick' + (t % 10 === 0 ? ' trc-sizer__tick--cm' : '');
        tick.style.height = (t % 10 === 0 ? 22 : t % 5 === 0 ? 15 : 9) + 'px';
        ruler.appendChild(tick);
        ticks.push(tick);

        if (t % 10 === 0) {
          var lab = document.createElement('span');
          lab.className = 'trc-sizer__cm-label';
          lab.textContent = t / 10;
          ruler.appendChild(lab);
          labels.push({ el: lab, mm: t });
        }
      }
    })();

    /* PORTRAIT ON MOBILE. A landscape card at true scale is 85.6mm = 325px+,
       which does not fit a phone. Rotated, the short edge (53.98mm) leads and it
       fits easily. The scale is identical either way - only the axis swaps. */
    function drawCard() {
      var portrait = isMobile();
      var wMm = portrait ? CARD_SHORT_MM : CARD_LONG_MM;
      var hMm = portrait ? CARD_LONG_MM : CARD_SHORT_MM;

      card.style.width = wMm * pxPerMm + 'px';
      card.style.height = hMm * pxPerMm + 'px';

      root.setAttribute('data-orient', portrait ? 'portrait' : 'landscape');
    }

    function drawRuler() {
      ruler.style.width = RULER_MM * pxPerMm + 'px';
      for (var t = 0; t < ticks.length; t++) {
        ticks[t].style.left = t * pxPerMm + 'px';
      }
      for (var l = 0; l < labels.length; l++) {
        labels[l].el.style.left = labels[l].mm * pxPerMm + 'px';
      }
    }

    function drawScale() {
      drawCard();
      drawRuler();
    }

    function currentSize() {
      return SIZES[parseInt(sizeSlider.value, 10)];
    }

    function drawRing() {
      var s = currentSize();
      var d = s.mm * pxPerMm;

      ring.style.width = d + 'px';
      ring.style.height = d + 'px';

      sizeOut.textContent = 'US ' + s.us;
      mmOut.textContent = s.mm.toFixed(1) + ' mm internal diameter';
      convOut.textContent = 'AU/UK ' + s.au.replace('1/2', '\u00BD') + '  \u00B7  EU ' + s.eu;

      if (isWhole(s.us)) {
        statusOut.textContent = 'Standard size.';
        statusOut.className = 'trc-sizer__status trc-sizer__status--ok';
      } else {
        statusOut.textContent =
          'Half sizes are available on custom rings only. Our standard range is whole sizes.';
        statusOut.className = 'trc-sizer__status trc-sizer__status--note';
      }

      if (!hasPills || !chooseBtn) return;

      var pill = findPill(s.us);
      if (pill) {
        chooseBtn.disabled = false;
        chooseBtn.textContent = 'Choose size ' + s.us;
      } else if (isWhole(s.us)) {
        chooseBtn.disabled = true;
        chooseBtn.textContent = 'Size ' + s.us + ' not available on this ring';
      } else {
        chooseBtn.disabled = true;
        chooseBtn.textContent = 'Custom size - contact us';
      }
    }

    calSlider.addEventListener('input', function () {
      pxPerMm = parseFloat(calSlider.value);
      drawScale();
    });

    sizeSlider.addEventListener('input', drawRing);

    /* Rotating the phone, or resizing across the breakpoint, must re-orient. */
    window.addEventListener('resize', function () {
      drawScale();
      drawRing();
    });

    root.addEventListener('click', function (e) {
      var methodBtn = e.target.closest('[data-method-btn]');
      if (methodBtn) {
        root.setAttribute('data-method', methodBtn.getAttribute('data-method-btn'));
        drawScale();
        return;
      }

      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-action');

      if (action === 'calibrated') {
        saveCal(pxPerMm);
        root.setAttribute('data-step', 'measure');
        drawRing();
      } else if (action === 'recalibrate') {
        root.setAttribute('data-step', 'calibrate');
        drawScale();
      } else if (action === 'print') {
        printChart();
      } else if (action === 'choose') {
        var pill = findPill(currentSize().us);
        if (!pill) return;
        var label = document.querySelector('label[for=' + JSON.stringify(pill.id) + ']');
        if (label) {
          label.click();
        } else {
          pill.click();
        }
        var popup = root.closest('.product-popup-modal');
        var closeBtn = popup ? popup.querySelector('.product-popup-modal__toggle') : null;
        if (closeBtn) closeBtn.click();
        var group = document.querySelector('.product-form__input--pill');
        if (group) group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    drawScale();
    drawRing();

    if (loadCal()) root.setAttribute('data-step', 'measure');
  }

  function insert(target) {
    var tpl = document.getElementById('trc-ring-sizer-template');
    if (!tpl || !target) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    target.appendChild(node);
    build(node);
  }

  function bootPopup() {
    var modals = document.querySelectorAll('[id^=PopupModal-]');
    for (var i = 0; i < modals.length; i++) {
      var modal = modals[i];
      if (modal.getAttribute('data-trc-sizer')) continue;

      var opener = document.querySelector('modal-opener[data-modal="#' + modal.id + '"]');
      if (!opener) continue;
      if (!/ring size/i.test(opener.textContent || '')) continue;

      var target =
        modal.querySelector('.product-popup-modal__content-info') ||
        modal.querySelector('.product-popup-modal__content');
      if (!target) continue;

      modal.setAttribute('data-trc-sizer', 'true');
      insert(target);
    }
  }

  function bootPage() {
    if (!/ring-size/i.test(window.location.pathname)) return;
    var rte = document.querySelector('main .rte');
    if (!rte) return;
    if (rte.getAttribute('data-trc-sizer')) return;
    rte.setAttribute('data-trc-sizer', 'true');
    insert(rte);
  }

  function boot() {
    if (!document.getElementById('trc-ring-sizer-template')) return;
    bootPopup();
    bootPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('modal-opener')) setTimeout(boot, 0);
    },
    true
  );

  setTimeout(boot, 400);
  setTimeout(boot, 1500);
})();
